export type MatchStatus =
  | 'match'
  | 'alternative'
  | 'unavailable'
  | 'not-requested';

export const normalizeValue = (value: unknown): string | null => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  if (typeof value === 'boolean') {
    return value ? 'true' : 'false';
  }

  if (typeof value === 'number') {
    return String(value);
  }

  if (typeof value === 'string') {
    const lower = value.toLowerCase().trim();
    if (lower === 'yes' || lower === 'true' || lower === 'included') {
      return 'true';
    }
    if (
      lower === 'no' ||
      lower === 'false' ||
      lower === 'declined' ||
      lower === 'not selected'
    ) {
      return 'false';
    }

    const numericOnly = value.replace(/[$,\s]/g, '');
    const parsed = parseFloat(numericOnly);
    if (!isNaN(parsed)) {
      return String(parsed);
    }

    return lower;
  }

  return null;
};

export const getMatchStatus = (
  requestedValue: unknown,
  ratedValue: unknown,
  isRequested: boolean,
): MatchStatus => {
  if (!isRequested) {
    return 'not-requested';
  }

  const normalizedRequested = normalizeValue(requestedValue);
  const normalizedRated = normalizeValue(ratedValue);

  if (normalizedRated === null) {
    return 'unavailable';
  }

  if (normalizedRequested === null) {
    return 'alternative';
  }

  if (normalizedRequested === normalizedRated) {
    return 'match';
  }

  // Requested true but rated false = unavailable (not provided)
  if (normalizedRequested === 'true' && normalizedRated === 'false') {
    return 'unavailable';
  }

  return 'alternative';
};

export const getMatchStatusColor = (status: MatchStatus): string => {
  switch (status) {
    case 'match':
      return 'green.500';
    case 'alternative':
      return 'orange.400';
    case 'unavailable':
      return 'red.500';
    case 'not-requested':
      return 'gray.400';
  }
};
